import { EditableInputField, EditableTextareaField, FileField, OptionsField } from '../field';
import { SectionField } from '../field/section';
import { DynamicFormComponentRegistry } from '../field-registry';

export enum QuestionnaireComponentKind {
  Number = 'number',
  Date = 'date',
  Email = 'email',
  Url = 'url',
  Text = 'editable-textarea',
  Options = 'options',
  File = 'file',
  Section = 'section',
}

export const QuestionnaireComponentValidationPattern = {
  [QuestionnaireComponentKind.Url]: '^https?:\\/\\/.*',
  [QuestionnaireComponentKind.Email]: '^[^@]+@[^@]+.[a-z]{2,}$',
  [QuestionnaireComponentKind.Number]: null,
  [QuestionnaireComponentKind.Date]: null,
  [QuestionnaireComponentKind.Text]: null,
  [QuestionnaireComponentKind.Options]: null,
  [QuestionnaireComponentKind.File]: null,
  [QuestionnaireComponentKind.Section]: null,
};

// eslint-disable-next-line @typescript-eslint/no-empty-interface, @typescript-eslint/no-empty-object-type
export interface QuestionnaireFormFieldConfigExtra {}

export type QuestionnaireFormComponentRegistry = DynamicFormComponentRegistry<
  {
    [QuestionnaireComponentKind.Number]: EditableInputField;
    [QuestionnaireComponentKind.Date]: EditableInputField;
    [QuestionnaireComponentKind.Email]: EditableInputField;
    [QuestionnaireComponentKind.Url]: EditableInputField;
    [QuestionnaireComponentKind.Text]: EditableTextareaField;
    [QuestionnaireComponentKind.Options]: OptionsField;
    [QuestionnaireComponentKind.File]: FileField;
    [QuestionnaireComponentKind.Section]: SectionField;
  },
  QuestionnaireFormFieldConfigExtra
>;
